import { render, staticRenderFns } from "./Title_JobCategory.vue?vue&type=template&id=6a48a421&scoped=true&"
import script from "./Title_JobCategory.vue?vue&type=script&lang=js&"
export * from "./Title_JobCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48a421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
